import { makeStyles, Button, Container, Grid, Typography, Paper, Box, FormControlLabel, FormGroup, RadioGroup, Radio, Checkbox, IconButton } from "@material-ui/core";
import React, { useRef, useEffect, useState, useMemo, useCallback, useContext } from "react";
import SectionLoader from "../../../sharedComponents/Loader/SectionLoader";
import DocumentViewer from "../commonComponents/DocumentViewer";
import Helper from "../../../common/Helper";
import DescriptionIcon from '@material-ui/icons/Description';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import DialogComponent from '../commonComponents/DialogComponent';
import { red } from "@material-ui/core/colors";
import { AppDataContext } from "../../../common/AppContext";

const useStyles = makeStyles((theme) => ({
    content: {
        display: 'flex',
        flexGrow: 1,
        padding: theme.spacing(3),
        background: '#f1f1f1',
        flexDirection: 'column',
        justifyContent: 'space-between'
    },
    contentPaper: {
        height: '100%',
        display: 'flex',
        flex: '1',
        overflow: 'auto',
        padding: theme.spacing(1, 0),
    },
    answerHead: {
        fontWeight: 'bold',
        marginTop: "10px"
    },
    correctanswerResult: {
        background: 'green',
        padding: '8px',
        marginBottom: '16px',
        border: '1px solid transparent',
        borderRadius: '8px',
        color: '#fff'
    },
    wronganswerResult: {
        background: 'red',
        padding: '8px',
        marginBottom: '16px',
        border: '1px solid transparent',
        borderRadius: '8px',
        color: '#fff'
    },
    root: {
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',
        padding: theme.spacing(4),
        zIndex: 0,
        background: '#f1f1f1',
        // marginTop: theme.mixins.toolbar.minHeight,
        '& .super-app-theme--header': {
            backgroundColor: '#1d428a',
            color: '#ffffff',
            paddingRight: theme.spacing(6)
        },
        '& .MuiDataGrid-iconSeparator': {
            display: 'none !important'
        }

        //margin: theme.spacing(1)
    },
    quizContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        flex: "1",
        [theme.breakpoints.up('lg')]: {
            padding: '0 25%'
        }
    },
    quizStartInfo: {
        fontSize: '1.2rem',
        fontWeight: '500',
        color: theme.palette.secondary.main,
        marginBottom: theme.spacing(1),
        textAlign: 'center',


    },
    questionInfo: {
        fontSize: '1rem',
        fontWeight: '400',
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(0.5),
        textAlign: 'center',


    },
    docResources: {
        background: theme.palette.primary.main,
        color: '#ffffff',
        padding: '0 8px',
        borderRadius: '16px',
        cursor: 'pointer',
    },
    questionNavContainer: {
        marginBottom: theme.spacing(2),
        padding: theme.spacing(1.5),
        borderRadius: '8px',
        border: '1px solid #d9d9d9',
        background: '#ffffff',
    },
    questionNavTitle: {
        fontWeight: 600,
        marginBottom: theme.spacing(1),
    },
    questionNavButtons: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
    },
    questionNavButton: {
        minWidth: '36px',
        height: '36px',
        borderRadius: '999px',
        padding: 0,
    }
}));

const QuizView = ({ content, totalNoOfQuestion, updateNextBtnState, enableNext, handleNextClick, onStartClick, selectedQuestion,
    handlePrevClick, handleSkipClick, isFirst, isLast, mediaURL, handleSubmitQuestion, answer, enableSubmit, updateSubmitButton, isMediaLoading, userAnswer, questionNo, onQuestionNavigate, onAnswerSelectionChange, completedQuestionIds = [], allQuestionsAnswered = false, onIncompleteSubmit }) => {
    const classes = useStyles();
    const {addSnackMessages}=useContext(AppDataContext);
    const listInnerRef = useRef();
    const [currentQuestion, setCurrentQuestion] = useState(selectedQuestion)
    const [selectedAnswer, setSelectedAnswer] = useState([]);
    const [document, setDocument] = useState()

    useEffect(() => {
        setCurrentQuestion(selectedQuestion)
        updateNextBtnState(false)
        setSelectedAnswer([])
    }, [selectedQuestion])
    useEffect(() => {
        if (userAnswer && userAnswer.length > 0) {
            let ans = userAnswer.map(item => parseInt(item))
            setSelectedAnswer(ans)

        }
    }, [userAnswer])

    const onScroll = () => {
        if (listInnerRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
            const isNearBottom = scrollTop + clientHeight >= scrollHeight;

            if (isNearBottom) {
                console.log("Reached bottom");
                //setAtBottom(true)
                updateNextBtnState(true)
            }
        }
    };

    useEffect(() => {
        const listInnerElement = listInnerRef.current;

        if (listInnerElement) {

            listInnerElement.addEventListener("scroll", onScroll);
            const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
            const isNearBottom = scrollTop + clientHeight >= scrollHeight;
            return () => {
                listInnerElement.removeEventListener("scroll", onScroll);
            };
        }
    }, [currentQuestion]);

    const handleStartClick = () => {
        onStartClick()
    }

    const handleChange = (event, isMultiSelect) => {
        event.preventDefault()
        var existingAns = [...selectedAnswer];
        var value = parseInt(event.target.value);
        if (isMultiSelect) {
            if (event.target.checked) {
                existingAns.push(value)
            } else {
                let i = existingAns.indexOf(value)
                existingAns.splice(i, 1)
            }
        }
        else {
            existingAns = existingAns.splice();
            existingAns.push(parseInt(value));
        }
        if (existingAns && existingAns.length > 0)
            updateSubmitButton(true);
        else updateSubmitButton(false);
        setSelectedAnswer(existingAns);
        if (onAnswerSelectionChange) {
            onAnswerSelectionChange(existingAns);
        }
    };

    const handleSubmitClick = () => {
        if(selectedAnswer.length === 0) {
             addSnackMessages([{
                            open: true,
                            severity: 'error',
                            message: "Please select an answer before submitting."
                        }]);
            return;
        }
        handleSubmitQuestion(selectedAnswer);
    }

    const isCurrentQuestionAnswered = Boolean(currentQuestion?.id) && completedQuestionIds.includes(currentQuestion.id);

    const shouldShowSubmitButton = Boolean(currentQuestion) && (enableSubmit || enableNext || isLast);
    const isSubmitDisabled = (!isLast && !enableSubmit);
    // const getFileExtn = useMemo(() => {
    //     if (currentQuestion?.documentName)
    //         return currentQuestion?.documentName.split('.').pop();
    //     else
    //         return ''
    // }, [currentQuestion?.documentName])


    const getIcon = (ext) => {

        switch (ext) {
            case 'pdf':
                return <PictureAsPdfIcon fontSize="medium" style={{ color: red[500] }} />

            default:
                return <DescriptionIcon fontSize="medium" style={{ color: '#ffffff' }} />
        }
    }
    const onDocumentClick = (name) => {

        setDocument(name)
    }

    const renderQuestionElement = useMemo(() => {
        if (currentQuestion?.documentName) {
            let ext = mediaURL?.split('.')?.pop()
            return <Box overflow='auto' display='flex' ref={listInnerRef}>
                {isMediaLoading ? <SectionLoader /> :
                    (ext == 'pdf' || ext == 'txt' || ext == 'xlxs' || ext == 'xls' || ext == 'doc' || ext == 'docx' || ext === 'ppt' || ext == 'pptx') ?
                        <Box component='div' className={classes.docResources} onClick={() => onDocumentClick(currentQuestion.documentName)}>
                            <Typography variant="caption">{currentQuestion?.documentDescription}</Typography>
                            <IconButton >
                                {getIcon(ext)}
                            </IconButton>
                        </Box>
                        : <DocumentViewer documentName={mediaURL} minHeight="226px" fileExtension={mediaURL?.split('.')?.pop() ?? ""} isFromQuiz={true} />
                }
            </Box>
        }
    }, [currentQuestion])



    const closeFileViwer = () => {
        setDocument(false);
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
            {/* <Toolbar /> */}
            <Box component="main" display="flex" flex="1">
                {/* <Paper square className={classes.contentPaper}> */}
                <Container maxWidth="false">
                    <Grid container spacing={2} style={{ height: '100%' }}>
                        {!currentQuestion &&
                            <Grid item xs={12} alignContent="center" >
                                <Box display='flex' flexGrow='1'>
                                    <Box component='div' flexGrow={1} display='flex' alignItems='center' justifyContent='center' flexDirection='column'>
                                        {/* alignItems="center" alignContent="center" justifyContent="center" */}
                                        <Typography variant="body1" className={classes.quizStartInfo}>
                                            Click on start button to start quiz.
                                        </Typography>
                                        <Typography variant="body1" className={classes.questionInfo}>
                                            {'Total no of questions ' + totalNoOfQuestion ?? 0}
                                        </Typography>
                                        <Button variant="contained" color='primary' onClick={handleStartClick}>Start</Button>
                                    </Box>
                                </Box>
                            </Grid>}
                        {currentQuestion && <>
                            <Grid item xs={12} >
                                <Box component='div' className={classes.quizContainer}>
                                    {answer &&
                                        <Box>
                                            {/* <Typography variant="h6" className={answer?.isCorrect ? classes.correctanswerResult : classes.wronganswerResult}>
                                                {answer?.isCorrect ? 'You are correct. Please click Next to continue.' : 'Incorrect answer. Please try again.'}
                                            </Typography> */}
                                            {/* {answer?.isCorrect ?
                                                (answer?.rightAnswerHelpText &&
                                                    <Typography variant="body1">{answer?.rightAnswerHelpText}
                                                    </Typography>) :
                                                (answer?.wrongAnswerHelpText &&
                                                    <Typography variant="body1">{answer?.wrongAnswerHelpText}
                                                    </Typography>)
                                            } */}
                                        </Box>
                                    }
                                    <Box display='flex' flexDirection='column' marginBottom='16px'>
                                        <Paper elevation={0} className={classes.questionNavContainer}>
                                            <Typography variant="subtitle2" className={classes.questionNavTitle}>
                                                Question Navigation
                                            </Typography>
                                            <Box className={classes.questionNavButtons}>
                                                {content.map((question, index) => {
                                                    const isCurrentQuestion = currentQuestion?.id === question.id;
                                                    const isCompletedQuestion = completedQuestionIds.includes(question.id);
                                                    let buttonStyle = {};
                                                    let buttonTextStyle = {};

                                                    if (isCurrentQuestion) {
                                                        buttonStyle = {
                                                            backgroundColor: '#1d428a',
                                                            borderColor: '#1d428a',
                                                        };
                                                        buttonTextStyle = { color: '#ffffff' };
                                                    } else if (isCompletedQuestion) {
                                                        buttonStyle = {
                                                            backgroundColor: '#5f8fd5',
                                                            borderColor: '#5f8fd5',
                                                        };
                                                        buttonTextStyle = { color: '#ffffff' };
                                                    }

                                                    return (
                                                        <Button
                                                            key={question.id}
                                                            variant={isCurrentQuestion || isCompletedQuestion ? "contained" : "outlined"}
                                                            color={isCurrentQuestion || isCompletedQuestion ? "primary" : "default"}
                                                            size="small"
                                                            className={classes.questionNavButton}
                                                            onClick={() => onQuestionNavigate && onQuestionNavigate(question)}
                                                            style={buttonStyle}
                                                        >
                                                            <span style={buttonTextStyle}>{index + 1}</span>
                                                        </Button>
                                                    );
                                                })}
                                            </Box>
                                        </Paper>
                                        <Typography variant="subtitle1" component="div" className={classes.answerHead}>
                                            {`Question ${questionNo}:`}
                                        </Typography>
                                        <Typography variant="body1" style={{ marginBottom: '8px' }}>
                                            {Helper.stripHtmlTags(currentQuestion?.questionTitle ?? '')}
                                        </Typography>
                                        {renderQuestionElement}
                                        {currentQuestion.questionDescription && <Typography variant="subtitle2" color="text.secondary">
                                            {`Hint: ${currentQuestion.questionDescription}`}
                                        </Typography>}

                                        <Typography variant="subtitle1" component="div" className={classes.answerHead}>
                                            {`Answers: ${currentQuestion.isMultiSelect ? '(Choose multiple answers)' : ''}`}
                                        </Typography>
                                        <Box display="flex" alignItems="center" style={{ width: '100%' }}>
                                            <FormGroup>
                                                {currentQuestion.isMultiSelect &&
                                                    currentQuestion.answers.map((answer, i) => (
                                                        <FormControlLabel
                                                            key={i}
                                                            control={<Checkbox disabled={isCurrentQuestionAnswered} size="small" name="checkedC" checked={selectedAnswer.length > 0 && selectedAnswer.includes(answer.id)} value={answer.id} onChange={(e) => handleChange(e, true)} />}
                                                            label={<Typography variant="subtitle2">{answer.answer}</Typography>}
                                                        />
                                                    ))
                                                }
                                            </FormGroup>
                                            {!currentQuestion.isMultiSelect &&
                                                <RadioGroup onChange={(e) => handleChange(e, false)} className={classes.radioGroup}>
                                                    {currentQuestion.answers.map((answer, index) => {
                                                        return <FormControlLabel key={index} value={answer.id} checked={(selectedAnswer && selectedAnswer[0] === answer.id) ? true : false} control={<Radio disabled={isCurrentQuestionAnswered} />} label={answer.answer} />
                                                    })}
                                                </RadioGroup>
                                            }
                                            {/* {answer.isCorrect && (
                                                    <CheckCircle style={{ color: green[600], marginRight: 8 }} />
                                                )} */}
                                        </Box>
                                    </Box>
                                    <Box display="flex" alignItems="center" justifyContent="space-between" paddingBottom={1} style={{ width: '100%' }}>
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            color="secondary"
                                            onClick={handlePrevClick}
                                            disabled={isFirst || !currentQuestion}
                                        >
                                            Previous
                                        </Button>

                                        <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                color="default"
                                                onClick={handleSkipClick}
                                                disabled={!currentQuestion || isLast}
                                                style={{ display: isLast ? 'none' : 'block' }}
                                            >
                                                Skip
                                            </Button>
                                        <Button variant="contained" size="small" color="primary"
                                            onClick={handleSubmitClick}
                                            disabled={isSubmitDisabled}
                                          
                                        > {isLast ? 'Submit' : 'Submit & Next'}</Button>
                                        </Box>

                                    </Box>
                                </Box>
                            </Grid>
                        </>
                        }

                        {document && <DialogComponent
                            handleClose={closeFileViwer}
                            open={document ? true : false}
                            title="View"
                            childComponent={
                                <DocumentViewer
                                    documentName={document}
                                    fileExtension={document?.split('.').pop()}
                                />
                            }>
                        </DialogComponent>
                        }
                    </Grid>
                </Container>
                {/* </Paper> */}
            </Box>
            {/* <Box style={{ visibility: currentQuestion != '' ? 'visible' : 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '16px 0', position: 'sticky', bottom: '8px', background: '#ffffff', padding: '0 40px' }}>
                <Button style={{ visibility: isFirst == true || isFirst == undefined ? 'hidden' : 'visible' }} variant="contained" size="small" color="secondary" onClick={handlePrevClick}>
                    Previous
                </Button>
                <Button
                    style={{ visibility: isLast == undefined ? 'hidden' : 'visible' }}
                    variant="contained" size="small" color="primary"
                    onClick={handleNextClick}
                    disabled={!enableNext}>
                    Next
                </Button>
            </Box> */}
        </div>
    )
}

export default QuizView;